import { createClient } from "./utils/axios";
import { BASE_URI }     from "./constants/uri";

const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV || process.env.REACT_APP_ENV;

const axiosClient = createClient({
  baseUrl: BASE_URI[APP_ENV],
  withCreds: true,
});

axiosClient.interceptors.request.use(function (config) {
  if (APP_ENV !== "production") {
    const requestLog = `${config.method} ${config.baseURL}${config.url}`;
    console.debug(requestLog);
  }
  // Work around since axios doesnt set content-type if data is undefined
  config.headers["Accept"] = "application/json";
  config.headers["Content-Type"] = "application/json";

  if (!config?.data) {
    config.data = {};
  }
  // Do something before request is sent
  return config;
});

export default axiosClient;
